/* Personalizzazione Piquadro · landing (solo visiva)
   ------------------------------------------------------------------------
   Dal prototipo del collega restano geometria (matrice prospettica sui 4
   angoli del tag), stati e animazioni. Cambia:
   - NESSUN carrello: il bottone del riepilogo porta alla scheda prodotto;
   - prezzi gia' formattati in Liquid (| money), niente simbolo € nel JS;
   - init per istanza su [data-pz-page], con AbortController: nell'editor
     shopify:section:load reinizializza, shopify:section:unload pulisce;
   - niente ID globali: tutto e' cercato dentro la propria section;
   - shopify:block:select apre la scheda che contiene il blocco scelto;
   - link e bottoni senza destinazione (modulo assente) vengono nascosti. */
(() => {
  if (window.__pqPz) return;
  window.__pqPz = true;

  const $ = (s, r) => r.querySelector(s);
  const $$ = (s, r) => [...r.querySelectorAll(s)];
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* Testi di riserva: su Shopify arrivano dal blocco (data-pz-data → t) */
  const DEF_T = {
    defMono: 'MP', defPop: 'GL', defPhrase: 'MAKE IT YOURS', inputLabel: 'Initials (up to 3)',
    pick: 'Select', picked: 'Selected',
    sumMono: 'Monogram Tag', sumPop: 'POP Tag', sumLeather: 'Leather:', techUv: 'UV printing', techLaser: 'Laser engraving', plusGraphic: '+ graphic',
    noteMono: '', notePop: '', noteSurf: '',
    sumOn: 'on', sumChooseA: 'Choose the product to apply it to', sumChooseO: 'Choose the product to apply it to',
    ctaGo: 'Go to product', ctaChoose: 'Choose a product', mnext: 'Next',
    altMono: 'Backpack with leather Monogram Tag', punch: 'Stamping press', altPop: 'POP suitcase with personalized POP Tag', altPrint: 'with your phrase'
  };
  /* Monogram e POP: massimo 3 caratteri (iniziali) */
  const MAX_INITIALS = 3;

  /* Grafiche minimal: segni geometrici a tratto sottile */
  const ICONS = {
    linea: '<path d="M3 12h18"/>',
    cerchio: '<circle cx="12" cy="12" r="8"/>',
    quadrato: '<rect x="5" y="5" width="14" height="14"/>',
    freccia: '<path d="M4 12h16m-5-5 5 5-5 5"/>',
    orizzonte: '<path d="M2 18 9 8l4 5 3-3 6 8"/>',
    croce: '<path d="M12 5v14M5 12h14"/>'
  };

  /* Prospettiva: matrice che porta il rettangolo w×h sui 4 angoli del tag */
  const adj = m => [m[4]*m[8]-m[5]*m[7], m[2]*m[7]-m[1]*m[8], m[1]*m[5]-m[2]*m[4], m[5]*m[6]-m[3]*m[8], m[0]*m[8]-m[2]*m[6], m[2]*m[3]-m[0]*m[5], m[3]*m[7]-m[4]*m[6], m[1]*m[6]-m[0]*m[7], m[0]*m[4]-m[1]*m[3]];
  const mm = (a, b) => { const c = []; for (let i = 0; i < 3; i++) for (let j = 0; j < 3; j++) { let s = 0; for (let k = 0; k < 3; k++) s += a[3*i+k] * b[3*k+j]; c[3*i+j] = s; } return c; };
  const mv = (m, v) => [m[0]*v[0]+m[1]*v[1]+m[2]*v[2], m[3]*v[0]+m[4]*v[1]+m[5]*v[2], m[6]*v[0]+m[7]*v[1]+m[8]*v[2]];
  const basis = p => { const m = [p[0], p[2], p[4], p[1], p[3], p[5], 1, 1, 1]; const v = mv(adj(m), [p[6], p[7], 1]); return mm(m, [v[0], 0, 0, 0, v[1], 0, 0, 0, v[2]]); };
  const project = (w, h, dst) => {
    const t = mm(basis(dst), adj(basis([0, 0, w, 0, w, h, 0, h])));
    const f = t.map(x => x / t[8]);
    return `matrix3d(${f[0]},${f[3]},0,${f[6]},${f[1]},${f[4]},0,${f[7]},0,0,1,0,${f[2]},${f[5]},0,1)`;
  };

  /* Colore chiaro? (testo scuro sul chip del riepilogo) */
  /* Accetta #hex, rgb()/rgba() o un gradiente (usa il primo colore) */
  const isLight = c => {
    const str = String(c || '');
    let r, g, b;
    const hx = str.match(/#([0-9a-f]{6}|[0-9a-f]{3})\b/i);
    const rg = str.match(/rgba?\(\s*(\d+)[,\s]+(\d+)[,\s]+(\d+)/i);
    if (rg && (!hx || str.indexOf(rg[0]) < str.indexOf(hx[0]))) { [r, g, b] = [rg[1], rg[2], rg[3]].map(n => +n / 255); }
    else if (hx) { let h = hx[1]; if (h.length === 3) h = [...h].map(x => x + x).join(''); [r, g, b] = [0, 2, 4].map(i => parseInt(h.slice(i, i + 2), 16) / 255); }
    else return false;
    return 0.2126 * r + 0.7152 * g + 0.0722 * b > 0.6;
  };

  const headerOffset = page => {
    const sel = page.dataset.header;
    let h = null;
    try { h = sel ? document.querySelector(sel) : null; } catch (e) { h = null; }
    if (!h) return 0;
    const pos = getComputedStyle(h).position;
    return (pos === 'sticky' || pos === 'fixed') ? h.getBoundingClientRect().height : 0;
  };
  const scrollToEl = (page, el, instant) => {
    const y = el.getBoundingClientRect().top + scrollY - headerOffset(page) + 1;
    scrollTo({ top: y, behavior: instant || reduce() ? 'auto' : 'smooth' });
  };

  /* ====================================================================
     Configuratore
     ==================================================================== */
  const GO = { mono: ['iniziali', 'mono'], pop: ['iniziali', 'pop'], laser: ['prodotto', 'laser'], uv: ['prodotto', 'uv'], iniziali: ['iniziali'], prodotto: ['prodotto'] };

  function initLab(lab, page, on, isFirst) {
    let DATA = { t: {} };
    try { DATA = Object.assign(DATA, JSON.parse($('script[data-pz-data]', lab).textContent)); } catch (e) { /* JSON assente: griglie vuote */ }
    const T = Object.assign({}, DEF_T, DATA.t || {});

    const tabs = $$('.pz-tab', lab);
    const panels = $$('.pzc', lab);
    const P = { iniziali: $('.pzc[data-output="iniziali"]', lab), prodotto: $('.pzc[data-output="prodotto"]', lab) };
    const R = g => $$(`input[data-g="${g}"]`, lab);
    const chk = g => R(g).find(r => r.checked) || R(g)[0] || { value: '', dataset: {} };
    const byVal = (g, v) => R(g).find(r => r.value === v);
    const optData = (g, v) => (byVal(g, v) || {}).dataset || {};
    const setLabel = (g, name) => { const l = $(`[data-label="${g}"]`, lab); if (l) l.textContent = name || ''; };

    /* I colori e gli zaini sono theme block figli: non sanno di essere i primi,
       quindi la prima scelta la fissa lo script. */
    const markSel = g => R(g).forEach(r => { const sw = r.closest('.color-swatch'); if (sw) sw.classList.toggle('selected', r.checked); });
    ['leather', 'popcolor', 'bag', 'mcolor', 'popink', 'ink'].forEach(g => {
      const rs = R(g);
      if (rs.length && !rs.some(r => r.checked)) rs[0].checked = true;
      setLabel(g, chk(g).dataset.name);
      markSel(g);
    });

    const BAGS = {};
    R('bag').forEach(r => {
      const d = r.dataset;
      BAGS[r.value] = { name: d.name || '', src: d.img || '', w: +d.w || 1400, h: +d.h || 1400, quad: d.quad || '', box: (d.box || '400,380').split(',').map(Number), chip: d.chip || '#777', scale: +d.scale || 1, y: +(d.y || .5) };
    });

    const state = {
      output: 'iniziali',
      tag: chk('tag').value || 'mono', mono: T.defMono, pop: T.defPop,
      leather: chk('leather').value, leatherName: chk('leather').dataset.name || '',
      foil: chk('foil').value || 'secco', foilName: chk('foil').dataset.name || '',
      mtech: chk('mtech').value || 'laser', mtechName: chk('mtech').dataset.name || '', mtechAvail: chk('mtech').dataset.avail || '',
      monoColor: chk('mcolor').value || '#ffffff', monoColorName: chk('mcolor').dataset.name || '',
      popInk: chk('popink').value || '#ffffff', popInkName: chk('popink').dataset.name || '',
      popcolor: chk('popcolor').value, popName: chk('popcolor').dataset.name || '',
      tech: chk('tech').value || 'uv', phrase: T.defPhrase, icon: '', ink: chk('ink').value || '#ffffff', inkName: chk('ink').dataset.name || '',
      bag: chk('bag').value,
      pick: { mono: null, pop: null, prodotto: null }
    };
    const key = () => state.output === 'prodotto' ? 'prodotto' : state.tag;

    /* Cornice = area visibile della foto (object-fit: cover o contain), cosi' le sovrapposizioni restano allineate */
    const fitFrames = () => {
      $$('.pzv', lab).forEach(fig => {
        const img = $('img[data-photo]', fig), frame = $('.pzv__frame', fig);
        if (!img || !frame || fig.hidden) return;
        const cw = fig.clientWidth, ch = fig.clientHeight;
        const iw = img.naturalWidth || +img.getAttribute('width'), ih = img.naturalHeight || +img.getAttribute('height');
        if (!cw || !ch || !iw || !ih) return;
        const narrow = matchMedia('(max-width: 760px)').matches;
        const zoom = narrow && fig.dataset.zoomM ? +fig.dataset.zoomM : 1;
        const [fx, fy] = (fig.dataset.focus || '.5,.5').split(',').map(Number);
        const contain = fig.dataset.fit === 'contain';
        const s = contain ? Math.min(cw / iw, ch / ih) * (+fig.dataset.scale || 1) : Math.max(cw / iw, ch / ih) * zoom;
        const w = iw * s, h = ih * s;
        const left = contain ? (cw - w) / 2 : Math.min(0, Math.max(cw - w, cw / 2 - fx * w));
        const top = contain ? (ch - h) * (+(fig.dataset.y || .5)) : Math.min(0, Math.max(ch - h, ch / 2 - fy * h));
        const geo = { width: w + 'px', height: h + 'px', left: left + 'px', top: top + 'px' };
        Object.assign(frame.style, geo);
        Object.assign(img.style, geo);
        const quad = $('[data-quad]', frame);
        if (quad && quad.dataset.quad && quad.dataset.quad.trim()) {
          // angoli relativi alla foto (0-1) → pixel a schermo; valori > 1 = pixel della foto originale
          const q0 = quad.dataset.quad.trim().split(/\s+/).map(p => p.split(',').map(Number));
          if (q0.length !== 4 || q0.flat().some(Number.isNaN)) return;
          const relQ = q0.flat().every(v => v <= 1.5);
          const q = relQ ? q0.map(([x, y]) => [x * w, y * h]) : q0.map(([x, y]) => [x * w / iw, y * w / iw]);
          const lerp = (a, b, t) => [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t];
          const f = 'full' in quad.dataset ? 1 : .8;
          const tl = q[0], tr = q[1], br = lerp(q[1], q[2], f), bl = lerp(q[0], q[3], f);
          quad.style.transform = project(quad.offsetWidth, quad.offsetHeight, [tl, tr, br, bl].flat());
        }
      });
    };

    /* ---------- Anteprime ---------- */
    const swapPhoto = (img, src) => {
      if (!img || !src || img.getAttribute('src') === src) return;
      if (!img.getAttribute('src')) { img.src = src; return; }   // prima foto: niente dissolvenza
      img.classList.add('is-loading');
      const nx = new Image();
      nx.onload = () => { img.src = src; img.classList.remove('is-loading'); fitFrames(); };
      nx.onerror = () => img.classList.remove('is-loading');
      nx.src = src;
    };
    const firstImg = g => (R(g).find(r => r.dataset.img) || { dataset: {} }).dataset.img;
    const photoFor = (g, v, img) => optData(g, v).img || (img.getAttribute('src') ? '' : firstImg(g));
    const pop = el => { if (reduce()) return; el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop'); };

    const renderIniziali = anim => {
      const p = P.iniziali; if (!p) return;
      p.dataset.tag = state.tag;
      const vMono = $('[data-view="mono"]', p), vPop = $('[data-view="pop"]', p);
      vMono.hidden = state.tag !== 'mono';
      vPop.hidden = state.tag !== 'pop';
      $$('[data-only="mono"]', p).forEach(f => { f.hidden = state.tag !== 'mono'; });
      $$('[data-only="pop"]', p).forEach(f => { f.hidden = state.tag !== 'pop'; });
      const input = $('[data-input]', p);
      const isMono = state.tag === 'mono';
      input.maxLength = MAX_INITIALS;
      input.placeholder = isMono ? T.defMono : T.defPop;
      if (document.activeElement !== input) input.value = isMono ? state.mono : state.pop;
      $('[data-input-label]', p).textContent = T.inputLabel;
      $('[data-count]', p).textContent = `${input.value.length} / ${input.maxLength}`;
      if (isMono) {
        const img = $('img[data-photo]', vMono), src = photoFor('leather', state.leather, img);
        if (src) swapPhoto(img, src);
        img.alt = [T.altMono, state.leatherName].filter(Boolean).join(' · ');
        // il corpo si adatta alla lunghezza per restare dentro l'inserto (rettangolo 400 px)
        const txt = state.mono || T.defMono;
        $$('[data-mtech-only]', p).forEach(f => { f.hidden = f.dataset.mtechOnly !== state.mtech; });
        $$('.pzv__mono', p).forEach(m => { m.textContent = txt; m.dataset.foil = state.mtech === 'punch' ? state.foil : state.mtech; m.style.setProperty('--mc', state.monoColor); m.style.fontSize = Math.min(150, Math.round(360 / (txt.length * .7))) + 'px'; });
        if (anim) pop(vMono);
      } else {
        const img = $('img[data-photo]', vPop), src = photoFor('popcolor', state.popcolor, img);
        if (src) swapPhoto(img, src);
        img.alt = [T.altPop, state.popName].filter(Boolean).join(' · ');
        const box = $('[data-box]', vPop);
        const b = (box.dataset.box || '0.2955,0.5057,0.7045,0.6307').split(',').map(Number);
        Object.assign(box.style, { left: b[0] * 100 + '%', top: b[1] * 100 + '%', width: (b[2] - b[0]) * 100 + '%', height: (b[3] - b[1]) * 100 + '%' });
        const out = $('[data-out]', box);
        out.textContent = state.pop || T.defPop;
        out.style.color = state.popInk;
        if (anim) pop(vPop);
      }
      fitFrames();
    };

    let runT;
    const runPrint = () => {
      if (reduce() || !P.prodotto) return;
      const fig = $('.pzv', P.prodotto);
      fig.classList.remove('is-run'); void fig.offsetWidth; fig.classList.add('is-run');
    };
    const renderProdotto = anim => {
      const p = P.prodotto; if (!p) return;
      p.dataset.tech = state.tech;
      p.dataset.ink = 'palette';
      p.style.setProperty('--uv-c', state.ink);
      $$('[data-only="uv"]', p).forEach(f => { f.hidden = state.tech !== 'uv'; });
      const input = $('[data-input]', p);
      $('[data-count]', p).textContent = `${input.value.length} / ${input.maxLength}`;
      const fig = $('.pzv', p), B = BAGS[state.bag];
      if (!B) return;                                   // nessun blocco Zaino: resta solo il testo
      const img = $('img[data-photo]', fig), quad = $('[data-quad]', fig);
      fig.dataset.bag = state.bag;
      Object.assign(fig.dataset, { scale: B.scale, y: B.y });
      if (img.getAttribute('src') !== B.src) { img.setAttribute('width', B.w); img.setAttribute('height', B.h); swapPhoto(img, B.src); }
      quad.dataset.quad = B.quad;
      Object.assign(quad.style, { width: B.box[0] + 'px', height: B.box[1] + 'px' });
      img.alt = `${B.name} ${T.altPrint}`.trim();
      $('[data-out]', fig).textContent = state.phrase || T.defPhrase;
      $('[data-icon]', fig).innerHTML = state.icon && ICONS[state.icon] ? `<svg viewBox="0 0 24 24" aria-hidden="true">${ICONS[state.icon]}</svg>` : '';
      if (anim) { clearTimeout(runT); runT = setTimeout(runPrint, 120); }
      fitFrames();
    };

    /* ---------- 03 · Caroselli (card del tema, rese in Liquid) ----------
       Un gruppo per collezione; Monogram ne ha due (incluso e predisposto)
       che condividono la stessa scelta. Il bottone Select sceglie, il clic
       sulla card apre la PDP come nel resto del sito. */
    const groups = $$('[data-pz-group]', lab);
    const gridTitle = $('[data-grid-title]', lab);
    const markPicked = () => {
      const pk = state.pick[key()];
      $$('.pzp__slide', lab).forEach(sl => {
        const on = !!pk && pk.el === sl;
        sl.classList.toggle('is-picked', on);
        const b = $('[data-pz-pick]', sl);
        if (b) { b.setAttribute('aria-pressed', on); b.textContent = on ? T.picked : T.pick; }
      });
    };
    const updArrows = track => {
      const g = track.closest('[data-pz-group]'); if (!g) return;
      const max = track.scrollWidth - track.clientWidth - 2;
      $$('[data-pz-scroll]', g).forEach(a => { a.disabled = +a.dataset.pzScroll < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max; });
    };
    const renderGrid = () => {
      const k = key();
      groups.forEach(g => { g.hidden = g.dataset.pzGroup !== k; });
      markPicked();
      $$('[data-pz-track]', lab).forEach(updArrows);
    };
    on(lab, 'click', e => {
      const arrow = e.target.closest('[data-pz-scroll]');
      if (arrow) {
        const track = $('[data-pz-track]', arrow.closest('[data-pz-group]'));
        if (track) track.scrollBy({ left: +arrow.dataset.pzScroll * track.clientWidth * .9, behavior: reduce() ? 'auto' : 'smooth' });
        return;
      }
      const b = e.target.closest('[data-pz-pick]'); if (!b) return;
      const sl = b.closest('.pzp__slide'), k = key(), cur = state.pick[k];
      state.pick[k] = cur && cur.el === sl ? null : { el: sl, h: sl.dataset.h, t: sl.dataset.t };
      markPicked(); renderSummary();
    });
    $$('[data-pz-track]', lab).forEach(t => { on(t, 'scroll', () => updArrows(t), { passive: true }); });
    on(window, 'resize', () => $$('[data-pz-track]', lab).forEach(updArrows));

    /* ---------- Riepilogo (solo visivo: porta alla scheda prodotto) ---------- */
    const S = $('[data-summary]', lab);
    const swatch = (g, v) => {
      const r = byVal(g, v), sp = r && r.nextElementSibling;
      if (!sp) return '';
      const c = sp.style.getPropertyValue('--c');
      if (c) return c;                                   // swatch con colore inline (blocchi)
      const cs = getComputedStyle(sp);                   // swatch PDP: colore da [data-color]
      return cs.backgroundImage && cs.backgroundImage !== 'none' ? cs.backgroundImage : cs.backgroundColor;
    };
    const renderSummary = () => {
      if (!S) return;
      const k = key(), pick = state.pick[k];
      const chip = $('[data-sum-chip]', S);
      let what, note;
      if (k === 'mono') {
        const mono = state.mono || T.defMono;
        const techTxt = state.mtech === 'punch' ? [state.mtechName, state.foilName].filter(Boolean).join(' ')
          : state.mtech === 'color' ? [state.mtechName, state.monoColorName].filter(Boolean).join(' ') : state.mtechName;
        what = [`${T.sumMono} ${mono}`, state.leatherName && `${T.sumLeather} ${state.leatherName}`, techTxt, state.mtechAvail].filter(Boolean).join(' · ');
        chip.className = 'pzs__chip' + (mono.length > 3 ? ' pzs__chip--wide' : ''); chip.textContent = mono;
        chip.style.background = swatch('leather', state.leather);
        chip.style.color = state.mtech === 'color' ? state.monoColor : state.mtech === 'laser' ? 'rgba(0,0,0,.5)'
          : state.foil === 'argento' ? '#e8e8ea' : state.foil === 'secco' ? 'rgba(0,0,0,.45)' : '#e9c56a';
        note = T.noteMono;
      } else if (k === 'pop') {
        const popT = state.pop || T.defPop;
        what = [`${T.sumPop} «${popT}»`, state.popName, state.popInkName].filter(Boolean).join(' · ');
        const c = swatch('popcolor', state.popcolor);
        chip.className = 'pzs__chip is-text'; chip.textContent = popT;
        chip.style.background = c; chip.style.color = state.popInk;
        note = T.notePop;
      } else {
        const phrase = state.phrase || T.defPhrase;
        what = `${state.tech === 'uv' ? T.techUv : T.techLaser} «${phrase}»${state.icon ? ' ' + T.plusGraphic : ''}${state.tech === 'uv' && state.inkName ? ' · ' + state.inkName : ''}`;
        const B = BAGS[state.bag];
        chip.className = 'pzs__chip is-text'; chip.textContent = phrase.slice(0, 14);
        chip.style.background = B ? B.chip : '#777'; chip.style.color = '#fff';
        note = T.noteSurf;
      }
      $('[data-sum-title]', S).textContent = what;
      $('[data-sum-product]', S).textContent = pick ? `${T.sumOn} ${pick.t}` : (k === 'prodotto' ? T.sumChooseA : T.sumChooseO);
      // niente prezzo: cambia da paese a paese e con la personalizzazione scelta in PDP
      $('[data-sum-price]', S).innerHTML = pick && note ? `<small>${esc(note)}</small>` : '';
      const cta = $('[data-sum-cta]', S);
      const link = pick && pick.el && pick.el.querySelector('a[href*="/products/"]');
      if (link) { cta.textContent = T.ctaGo; cta.href = link.getAttribute('href'); }   // variante scelta con i punti colore della card
      else { cta.textContent = T.ctaChoose; cta.href = '#' + (gridTitle.id || ''); }
    };
    const cta = S && $('[data-sum-cta]', S);
    if (cta) on(cta, 'click', e => {
      const pk = state.pick[key()];
      if (pk) {                                        // prodotto scelto: link alla PDP con la variante scelta ORA nella card
        const link = pk.el && pk.el.querySelector('a[href*="/products/"]');
        if (link) cta.href = link.getAttribute('href');
        return;
      }
      e.preventDefault();
      scrollToEl(page, gridTitle);
    });

    /* ---------- Schede ---------- */
    const activate = (output, opts = {}) => {
      if (!P[output]) return;
      state.output = output;
      lab.dataset.output = output;
      const pzRoot = lab.closest('.pz'); if (pzRoot) pzRoot.dataset.tech = output === 'prodotto' ? 'uv' : 'mono';
      tabs.forEach(t => { const act = t.dataset.output === output; t.setAttribute('aria-selected', act); t.tabIndex = act ? 0 : -1; });
      panels.forEach(p => { const act = p.dataset.output === output; p.hidden = !act; if (act) { p.classList.remove('is-in'); void p.offsetWidth; p.classList.add('is-in'); } });
      output === 'iniziali' ? renderIniziali(true) : renderProdotto(true);
      renderGrid(); renderSummary();
      refreshSteps();
      if (opts.focus) { const t = tabs.find(x => x.dataset.output === output); if (t) t.focus(); }
    };
    tabs.forEach((t, i) => {
      on(t, 'click', () => activate(t.dataset.output));
      on(t, 'keydown', e => {
        const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return;
        e.preventDefault(); activate(tabs[(i + d + tabs.length) % tabs.length].dataset.output, { focus: true });
      });
    });
    /* ---------- Mobile: un passo alla volta ----------
       Le parti dei controlli hanno data-mstep, i bottoni data-mstep-go. Il CSS
       nasconde le parti .is-mstep-off solo fino a 760 px: sopra non cambia nulla. */
    const SWAP = { leather: 'popcolor', popcolor: 'leather', mtech: 'popink', popink: 'mtech' };
    const steppers = panels.map(panel => {
      const nav = $('[data-msteps]', panel); if (!nav) return null;
      const next = $('[data-mnext]', panel);
      const visibili = () => $$('[data-mstep-go]', nav).filter(b => !b.hidden);
      let cur = (visibili()[0] || {}).dataset ? visibili()[0].dataset.mstepGo : '';
      const set = (key, focus) => {
        const vis = visibili();
        if (!vis.some(b => b.dataset.mstepGo === key)) key = vis.some(b => b.dataset.mstepGo === SWAP[key]) ? SWAP[key] : (vis[0] && vis[0].dataset.mstepGo);
        cur = key;
        $$('[data-mstep]', panel).forEach(u => u.classList.toggle('is-mstep-off', u.dataset.mstep !== key));
        vis.forEach(b => {
          if (b.dataset.mstepGo !== key) { b.removeAttribute('aria-current'); return; }
          b.setAttribute('aria-current', 'step');
          // porta in vista il passo scorrendo SOLO la fila dei passi in orizzontale:
          // scrollIntoView muoveva anche la pagina e al caricamento la portava fino al configuratore
          if (nav.scrollWidth > nav.clientWidth) nav.scrollLeft += b.getBoundingClientRect().left - nav.getBoundingClientRect().left - 16;
        });
        $$('[data-mstep-go]', nav).forEach(b => { if (b.hidden) b.removeAttribute('aria-current'); });
        if (next) {
          const i = vis.findIndex(b => b.dataset.mstepGo === key), nb = vis[i + 1];
          next.textContent = nb ? `${T.mnext}: ${nb.textContent.trim()}` : T.ctaChoose;
          next.dataset.to = nb ? nb.dataset.mstepGo : '';
        }
        if (focus) { const b = vis.find(x => x.dataset.mstepGo === key); if (b) b.focus(); }
        fitFrames();
      };
      on(nav, 'click', e => { const b = e.target.closest('[data-mstep-go]'); if (b) set(b.dataset.mstepGo); });
      if (next) on(next, 'click', () => { if (next.dataset.to) set(next.dataset.to); else scrollToEl(page, gridTitle); });
      set(cur);
      return { panel, set, refresh: () => set(cur), has: el => el.closest('[data-mstep]') };
    }).filter(Boolean);
    const refreshSteps = () => steppers.forEach(st => st.refresh());

    const setRadio = (g, v) => { const r = byVal(g, v); if (r) r.checked = true; };
    const setTag = t => { state.tag = t; setRadio('tag', t); };
    const setTech = t => { state.tech = t; setRadio('tech', t); };
    const go = (k, opts = {}) => {
      const map = GO[k]; if (!map) return;
      if (map[1] === 'mono' || map[1] === 'pop') setTag(map[1]);
      if (map[1] === 'laser' || map[1] === 'uv') setTech(map[1]);
      activate(map[0]);
      if (opts.scroll !== false) scrollToEl(page, lab);
    };

    /* ---------- Controlli ---------- */
    const sanitizeInit = v => v.replace(/[^A-Za-zÀ-ÿ&. ]/g, '');
    const sanitizeText = v => v.replace(/[^A-Za-zÀ-ÿ0-9&.'!?,\- ]/g, '');
    let deb;
    if (P.iniziali) on($('[data-input]', P.iniziali), 'input', e => {
      const i = e.target;
      const v = sanitizeInit(i.value).replace(/[ .&]/g, '').slice(0, MAX_INITIALS).toUpperCase();
      if (v !== i.value) i.value = v;
      state[state.tag] = v.trim();
      renderIniziali(false); renderSummary();
      clearTimeout(deb); deb = setTimeout(() => renderIniziali(true), 500);
    });
    if (P.prodotto) on($('[data-input]', P.prodotto), 'input', e => {
      const i = e.target, v = sanitizeText(i.value);
      if (v !== i.value) i.value = v;
      state.phrase = v.trim();
      renderProdotto(false); renderSummary();
      clearTimeout(deb); deb = setTimeout(() => renderProdotto(true), 500);
    });
    on(lab, 'change', e => {
      const r = e.target; if (r.type !== 'radio' || !r.dataset.g) return;
      const g = r.dataset.g, v = r.value, nm = r.dataset.name || '';
      if (nm) setLabel(g, nm);
      markSel(g);
      switch (g) {
        case 'tag': state.tag = v; renderIniziali(true); renderGrid(); refreshSteps(); break;
        case 'leather': state.leather = v; state.leatherName = nm; renderIniziali(true); break;
        case 'foil': state.foil = v; state.foilName = nm; renderIniziali(true); break;
        case 'mtech': state.mtech = v; state.mtechName = nm; state.mtechAvail = r.dataset.avail || ''; renderIniziali(true); break;
        case 'popcolor': state.popcolor = v; state.popName = nm; renderIniziali(true); break;
        case 'tech': state.tech = v; renderProdotto(true); refreshSteps(); break;
        case 'icon': state.icon = v; renderProdotto(true); break;
        case 'ink': state.ink = v; state.inkName = nm; renderProdotto(true); break;
        case 'mcolor': state.monoColor = v; state.monoColorName = nm; renderIniziali(true); break;
        case 'popink': state.popInk = v; state.popInkName = nm; renderIniziali(true); break;
        case 'bag': state.bag = v; renderProdotto(true); break;
      }
      renderSummary();
    });
    $$('[data-replay]', lab).forEach(b => on(b, 'click', runPrint));
    on(window, 'resize', fitFrames);
    $$('img[data-photo]', lab).forEach(i => on(i, 'load', fitFrames));
    const grid03 = $('.pzp', lab);
    const sumOn = () => { if (grid03) lab.classList.toggle('is-sum-on', grid03.getBoundingClientRect().top < innerHeight * .85); };
    on(window, 'scroll', sumOn, { passive: true }); on(window, 'resize', sumOn); sumOn();

    /* ---------- Arrivo dalla home ----------
       ?output=iniziali|prodotto  &tag=mono|pop  &tecnica=uv|laser  &testo=XX
       + dal configuratore home: pelle, colore, mtech, mcolore, lamina, frase, zaino, inchiostro */
    let arrived = false;
    if (isFirst) {
      const q = new URLSearchParams(location.search);
      let out = q.get('output'), tech = q.get('tecnica'), tg = q.get('tag');
      if (tech === 'mono') { out = 'iniziali'; tg = 'mono'; tech = null; }
      if (tech === 'laser' || tech === 'uv') { out = 'prodotto'; setTech(tech); }
      if (tg === 'mono' || tg === 'pop') setTag(tg);
      const txt = (q.get('testo') || '').trim();
      if (txt) {
        const ini = sanitizeInit(txt).replace(/[ .&]/g, '').slice(0, MAX_INITIALS).toUpperCase();
        state.mono = ini || T.defMono;
        state.pop = ini || T.defPop;
        state.phrase = sanitizeText(txt).slice(0, 18).toUpperCase() || T.defPhrase;
        if (P.prodotto) $('[data-input]', P.prodotto).value = state.phrase;
      }
      /* scelte complete dal configuratore della home (tutte facoltative):
         &pelle=<id variante> &colore=<id variante POP> &pcolore=#hex (iniziali POP) &mtech=laser|color|punch
         &mcolore=#hex &lamina=oro|argento|secco &frase=… &zaino=<posizione> &inchiostro=#hex */
      const scegli = (g, v, k, nk) => {
        const r = v && R(g).find(x => x.value.toLowerCase() === String(v).toLowerCase());
        if (!r) return null;
        r.checked = true; state[k] = r.value; if (nk) state[nk] = r.dataset.name || '';
        setLabel(g, r.dataset.name); markSel(g);
        return r;
      };
      const extra = [
        scegli('leather', q.get('pelle'), 'leather', 'leatherName'),
        scegli('popcolor', q.get('colore'), 'popcolor', 'popName'),
        scegli('popink', q.get('pcolore'), 'popInk', 'popInkName'),
        scegli('mcolor', q.get('mcolore'), 'monoColor', 'monoColorName'),
        scegli('foil', q.get('lamina'), 'foil', 'foilName'),
        scegli('ink', q.get('inchiostro'), 'ink', 'inkName')
      ];
      const mt = scegli('mtech', q.get('mtech'), 'mtech', 'mtechName');
      if (mt) state.mtechAvail = mt.dataset.avail || '';
      const zi = parseInt(q.get('zaino'), 10), zr = zi > 0 ? R('bag')[zi - 1] : null;
      if (zr) { zr.checked = true; state.bag = zr.value; setLabel('bag', zr.dataset.name); }
      const fr = (q.get('frase') || '').trim();
      if (fr) {
        state.phrase = sanitizeText(fr).slice(0, 18).toUpperCase() || T.defPhrase;
        if (P.prodotto) $('[data-input]', P.prodotto).value = state.phrase;
      }
      activate(out === 'prodotto' ? 'prodotto' : 'iniziali');
      arrived = !!(out || tech || tg || txt || fr || mt || zr || extra.some(Boolean));
    } else {
      activate('iniziali');
    }
    if (arrived && !window.Shopify?.designMode) {
      const land = () => { scrollToEl(page, lab, true); fitFrames(); };
      if (document.readyState === 'complete') land(); else on(window, 'load', land, { once: true });
    }
    fitFrames();

    /* Editor: il blocco selezionato apre la scheda che lo contiene */
    const select = el => {
      const panel = el.closest('.pzc');
      const only = el.closest('[data-only]');
      if (only && (only.dataset.only === 'mono' || only.dataset.only === 'pop')) setTag(only.dataset.only);
      if (panel) activate(panel.dataset.output);
      const unit = el.closest('[data-mstep]');
      const st = unit && steppers.find(x => x.panel.contains(unit));
      if (st) st.set(unit.dataset.mstep);
    };
    return { el: lab, go, select, fit: fitFrames };
  }

  /* ====================================================================
     Pagina
     ==================================================================== */
  function initPage(page) {
    if (page.__pz) return;
    const ac = new AbortController();
    const timers = [];
    const on = (t, ev, fn, o = {}) => t && t.addEventListener(ev, fn, Object.assign({}, o, { signal: ac.signal }));
    page.__pz = { ac, timers };

    /* Altezza della testata fissa: la usano le parti sticky del CSS (--hd-h) */
    const setVar = () => page.style.setProperty('--pz-header-h', headerOffset(page) + 'px');
    setVar(); on(window, 'resize', setVar); on(window, 'load', setVar);

    /* ---------- Apertura: titolo che si imprime ---------- */
    const titles = $$('[data-split]', page);
    titles.forEach(title => {
      const label = title.textContent.trim();
      let n = 0;
      title.innerHTML = label.split(' ').map(w =>
        `<span class="w">${[...w].map(c => `<span class="ch${c === '.' ? ' ch--dot' : ''}" style="--i:${n++}">${esc(c)}</span>`).join('')}</span>`
      ).join(' ');
      title.style.setProperty('--n', n);
      title.setAttribute('aria-label', label);
    });

    /* ---------- Configuratori ---------- */
    const labs = $$('[data-pz-lab]', page).map((l, i) => initLab(l, page, on, i === 0));
    const lab = labs[0];

    /* ---------- Link interni: senza destinazione si nascondono ---------- */
    $$('[data-go]', page).forEach(a => {
      const k = a.dataset.go;
      if (!k) return;
      if (k === 'making') {
        const target = $('[data-pz-anchor="making"]', page);
        if (!target) { a.hidden = true; return; }
        on(a, 'click', e => { e.preventDefault(); scrollToEl(page, target); });
        return;
      }
      if (!lab || !GO[k]) { a.hidden = true; return; }
      on(a, 'click', e => { e.preventDefault(); lab.go(k); });
    });

    /* ---------- In negozio: popup delle sedi con punzonatrice ----------
       Come il popup della PDP (pq-store-stock.js): stessi dati (/pages/sedi-json),
       stessa chiave Maps, stesso stile e marcatore. Mostra solo le sedi "pz". */
    $$('[data-pz-stores]', page).forEach(ov => initStores(ov, page, on, ac));

    /* ---------- Confronto da mobile: una colonna alla volta ---------- */
    $$('.pzl-cmp', page).forEach(cmp => {
      on(cmp, 'click', e => {
        const b = e.target.closest('[data-pz-col]'); if (!b) return;
        cmp.dataset.col = b.dataset.pzCol;
        $$('[data-pz-col]', cmp).forEach(x => x.setAttribute('aria-pressed', x === b));
      });
    });

    /* ---------- Domande frequenti: prima aperta ---------- */
    $$('.pzl-faq__list[data-open-first="true"]', page).forEach(l => {
      const d = $$('details', l);
      if (d.length && !d.some(x => x.open)) d[0].open = true;
    });

    /* ---------- Come nasce: reel fotografici ---------- */
    const reels = $$('.pzb__reel', page).map(r => ({ el: r, imgs: $$('img', r), i: 0 })).filter(r => r.imgs.length);
    reels.forEach(r => r.imgs[0].classList.add('is-on'));
    if (reels.some(r => r.imgs.length > 1)) {
      timers.push(setInterval(() => {
        if (document.hidden || reduce()) return;
        const vh = innerHeight || 800;
        reels.forEach(r => {
          if (r.imgs.length < 2) return;
          const b = r.el.getBoundingClientRect(); if (b.bottom < 0 || b.top > vh) return;
          r.imgs[r.i].classList.remove('is-on'); r.i = (r.i + 1) % r.imgs.length; r.imgs[r.i].classList.add('is-on');
        });
      }, 2600));
    }

    /* ---------- Scorrimento: il titolo si imprime ---------- */
    const onScroll = () => {
      const vh = innerHeight || document.documentElement.clientHeight; if (!vh) return;
      titles.forEach(title => {
        const tr = title.getBoundingClientRect();
        title.style.setProperty('--p', reduce() ? 1 : Math.min(1, Math.max(0, (vh * .95 - tr.top) / (vh * .5))).toFixed(3));
      });
    };
    on(window, 'scroll', onScroll, { passive: true });
    on(window, 'resize', onScroll);
    onScroll();

    page.__pz.select = el => {
      const l = labs.find(x => x.el.contains(el));
      if (l) l.select(el);
    };
  }

  /* ====================================================================
     Popup sedi con punzonatrice
     ==================================================================== */
  const MARCHIO = 'https://cdn.shopify.com/s/files/1/0616/7258/7444/files/favicon-black.png?v=1789475083';
  const STILE_MAPPA = [
    { featureType: 'poi', stylers: [{ visibility: 'off' }] },
    { featureType: 'transit', stylers: [{ visibility: 'off' }] },
    { featureType: 'road', elementType: 'labels', stylers: [{ visibility: 'simplified' }] },
    { featureType: 'water', stylers: [{ color: '#e9e9e7' }] },
    { featureType: 'landscape', stylers: [{ color: '#f7f6f4' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
    { featureType: 'administrative', elementType: 'labels.text.fill', stylers: [{ color: '#8c8880' }] }
  ];
  const CHIAVE_POS = 'pqPosizione';          // la stessa del popup PDP: la posizione si chiede una volta sola
  let sediPz = null;
  const caricaSediPz = url => sediPz || (sediPz = fetch(url).then(r => r.json()).then(d => (d.s || []).filter(x => x.pz && x.lt && x.lg)));
  const caricaMaps = key => {
    if (window.google && google.maps) return Promise.resolve();
    if (!key) return Promise.reject();
    if (window.pqMapsPromessa) return window.pqMapsPromessa;
    window.pqMapsPromessa = new Promise(ok => {
      window.pqMapsPronta = () => ok();
      const sc = document.createElement('script');
      sc.src = 'https://maps.googleapis.com/maps/api/js?key=' + key + '&callback=pqMapsPronta&loading=async';
      sc.async = true;
      document.head.appendChild(sc);
    });
    return window.pqMapsPromessa;
  };
  const distanza = (a, b, c, d) => {
    const R = 6371, dLat = (c - a) * Math.PI / 180, dLng = (d - b) * Math.PI / 180;
    const x = Math.sin(dLat / 2) ** 2 + Math.cos(a * Math.PI / 180) * Math.cos(c * Math.PI / 180) * Math.sin(dLng / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
  };
  const nomePulito = n => String(n || '').replace(/\s*S\.?p\.?A\.?\s*[–-]\s*/i, ' ').replace(/\bPza\b/i, 'Piazza').replace(/\bSt\.\s*/i, 'Stazione ').replace(/\s+/g, ' ').trim();

  function initStores(ov, page, on, ac) {
    const btn = $('[data-pz-stores-open]', page);
    if (!btn) return;
    const d = ov.dataset;
    const insegna = s => s.i === 'boutique' ? d.tBoutique : s.i === 'outlet' ? d.tOutlet : d.tReseller;
    const home = ov.parentNode, segnaposto = document.createComment('pz-stores');
    home.insertBefore(segnaposto, ov);
    const mapEl = $('[data-pz-stores-map]', ov), listEl = $('[data-pz-stores-list]', ov), titleEl = $('.pq-ss__panel-title', ov);
    let mappa = null, info = null, marcatori = [], ultimoFuoco = null;

    const scheda = s => {
      const ind = [s.a, s.a2].filter(Boolean).join(', '), loc = [s.z, s.c].filter(Boolean).join(' ');
      return `<span class="pq-ss__badge">${esc(insegna(s))}</span><h3 class="pq-ss__pname">${esc(nomePulito(s.n))}</h3>` +
        (ind ? `<p class="pq-ss__paddr">${esc(ind)}${loc ? '<br>' + esc(loc) : ''}</p>` : '') +
        (s.h ? `<p class="pq-ss__phours">${esc(s.h)}</p>` : '') + `<div class="pq-ss__pactions">${azioni(s)}</div>`;
    };
    // finestra sul marcatore: stessa struttura di contenutoInfo() nel popup della PDP
    const azioni = s => {
      const az = [];
      if (s.t) az.push(`<a href="tel:${esc(s.t.replace(/[^0-9+]/g, ''))}">${esc(s.t)}</a>`);
      az.push(`<a target="_blank" rel="noopener" href="https://www.google.com/maps/dir/?api=1&destination=${s.lt},${s.lg}">${esc(d.tDirections || 'Directions')}</a>`);
      return az.join('');
    };
    const infoHtml = s => {
      const ind = [s.a, s.a2].filter(Boolean).join(', '), loc = [s.z, s.c].filter(Boolean).join(' ');
      return `<div class="pq-ss__info"><span class="pq-ss__info-badge">${esc(insegna(s))}</span>` +
        `<h4 class="pq-ss__info-name">${esc(nomePulito(s.n))}</h4>` +
        `<p class="pq-ss__info-addr">${esc(ind)}${loc ? '<br>' + esc(loc) : ''}</p>` +
        (s.h ? `<p class="pq-ss__info-hours">${esc(s.h)}</p>` : '') +
        `<div class="pq-ss__info-actions">${azioni(s)}</div></div>`;
    };
    const vaiA = (s, li) => {
      $$('.pq-ss__pcard--attiva', listEl).forEach(c => c.classList.remove('pq-ss__pcard--attiva'));
      if (li) li.classList.add('pq-ss__pcard--attiva');
      if (!mappa) return;
      if (mappa.getZoom() < 13) mappa.setZoom(14);
      mappa.panTo({ lat: s.lt, lng: s.lg });
      const m = marcatori.find(x => x._s === s);
      if (m && info) { info.setContent(infoHtml(s)); info.open(mappa, m); }
      if (matchMedia('(max-width: 899px)').matches) mapEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    const riempi = sedi => {
      let pos = null;
      try { pos = JSON.parse(sessionStorage.getItem(CHIAVE_POS) || 'null'); } catch (e) { pos = null; }
      const elenco = pos ? sedi.slice().sort((a, b) => distanza(pos.lt, pos.lg, a.lt, a.lg) - distanza(pos.lt, pos.lg, b.lt, b.lg))
                         : sedi.slice().sort((a, b) => (a.pr || 3) - (b.pr || 3) || String(a.n).localeCompare(String(b.n)));
      listEl.innerHTML = '';
      elenco.forEach(s => {
        const li = document.createElement('li');
        li.className = 'pq-ss__pcard';
        li.innerHTML = scheda(s);
        li.addEventListener('click', e => { if (!e.target.closest('a')) vaiA(s, li); });
        listEl.appendChild(li);
      });
      if (!mappa) return;
      marcatori.forEach(m => m.setMap(null)); marcatori = [];
      const bounds = new google.maps.LatLngBounds();
      elenco.forEach(s => {
        const m = new google.maps.Marker({ position: { lat: s.lt, lng: s.lg }, map: mappa, title: nomePulito(s.n),
          icon: { url: MARCHIO, scaledSize: new google.maps.Size(26, 26), anchor: new google.maps.Point(13, 13) } });
        m._s = s;
        m.addListener('click', () => { info.setContent(infoHtml(s)); info.open(mappa, m); });
        marcatori.push(m); bounds.extend(m.getPosition());
      });
      if (marcatori.length === 1) { mappa.setCenter(marcatori[0].getPosition()); mappa.setZoom(14); }
      else if (marcatori.length) mappa.fitBounds(bounds, 48);
    };
    const chiediPosizione = sedi => {
      if (!navigator.geolocation) return;
      try { if (sessionStorage.getItem(CHIAVE_POS) || sessionStorage.getItem(CHIAVE_POS + 'No')) return; } catch (e) { return; }
      navigator.geolocation.getCurrentPosition(p => {
        try { sessionStorage.setItem(CHIAVE_POS, JSON.stringify({ lt: p.coords.latitude, lg: p.coords.longitude })); } catch (e) {}
        if (!ov.hidden) riempi(sedi);
      }, () => { try { sessionStorage.setItem(CHIAVE_POS + 'No', '1'); } catch (e) {} }, { timeout: 8000, maximumAge: 600000 });
    };
    const apri = sedi => {
      ultimoFuoco = document.activeElement;
      titleEl.textContent = (sedi.length === 1 ? d.tOne : (d.tMany || '').replace('[n]', sedi.length)) || '';
      document.body.appendChild(ov);                       // fuori dalla landing: stili del popup PDP puri
      ov.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      caricaMaps(d.mapsKey).catch(() => null).then(() => {
        if (!mappa && window.google && google.maps) {
          info = new google.maps.InfoWindow();
          mappa = new google.maps.Map(mapEl, { center: { lat: 44.5, lng: 11.3 }, zoom: 5, mapTypeControl: false, streetViewControl: false, fullscreenControl: false, styles: STILE_MAPPA });
        }
        mapEl.hidden = !mappa;
        riempi(sedi);
      });
      chiediPosizione(sedi);
      const x = $('[data-pz-stores-close]', ov); if (x) x.focus();
    };
    const chiudi = () => {
      ov.hidden = true;
      document.documentElement.style.overflow = '';
      if (ultimoFuoco && ultimoFuoco.focus) ultimoFuoco.focus();
    };
    on(btn, 'click', e => {
      e.preventDefault();
      const vai = () => { location.href = btn.getAttribute('href'); };
      caricaSediPz(d.sedi).then(sedi => (sedi.length ? apri(sedi) : vai())).catch(vai);
    });
    on(ov, 'click', e => { if (e.target.closest('[data-pz-stores-close]') || !e.target.closest('[data-pz-stores-panel]')) chiudi(); });
    on(document, 'keydown', e => { if (e.key === 'Escape' && !ov.hidden) chiudi(); });
    // alla chiusura della section (editor) il popup torna al suo posto e sparisce
    ac.signal.addEventListener('abort', () => { chiudi(); if (segnaposto.parentNode) segnaposto.parentNode.replaceChild(ov, segnaposto); else ov.remove(); });
  }

  function destroyPage(page) {
    if (!page.__pz) return;
    page.__pz.ac.abort();
    page.__pz.timers.forEach(clearInterval);
    page.__pz = null;
  }

  const boot = scope => $$('[data-pz-page]', scope || document).forEach(initPage);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();

  /* Theme editor */
  document.addEventListener('shopify:section:load', e => boot(e.target));
  document.addEventListener('shopify:section:unload', e => $$('[data-pz-page]', e.target).forEach(destroyPage));
  document.addEventListener('shopify:block:select', e => {
    const page = e.target && e.target.closest && e.target.closest('[data-pz-page]');
    if (page && page.__pz && page.__pz.select) page.__pz.select(e.target);
  });
})();
